import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
export var WizardNavItem = function WizardNavItem(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      _ref$isCurrent = _ref.isCurrent,
      isCurrent = _ref$isCurrent === void 0 ? false : _ref$isCurrent,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      step = _ref.step,
      _ref$onNavItemClick = _ref.onNavItemClick,
      onNavItemClick = _ref$onNavItemClick === void 0 ? function () {
    return undefined;
  } : _ref$onNavItemClick,
      _ref$navItemComponent = _ref.navItemComponent,
      navItemComponent = _ref$navItemComponent === void 0 ? 'a' : _ref$navItemComponent;
  var NavItemComponent = navItemComponent;
  return React.createElement("li", {
    className: css(styles.wizardNavItem)
  }, React.createElement(NavItemComponent, {
    "aria-current": isCurrent && !children ? 'page' : false,
    onClick: function onClick() {
      return onNavItemClick(step);
    },
    className: css(styles.wizardNavLink, isCurrent && 'pf-m-current', isDisabled && 'pf-m-disabled'),
    "aria-disabled": isDisabled ? true : false,
    tabIndex: isDisabled ? -1 : undefined
  }, content), children);
};